import { Component } from '@angular/core';

@Component({
  selector: 'app-page408',
  templateUrl: './page408.component.html',
  styleUrls: ['./page408.component.css'],
  standalone: false
})
export class Page408Component {

}
